import { render, staticRenderFns } from "./settingSelectedBlock.vue?vue&type=template&id=2d762359&scoped=true"
import script from "./settingSelectedBlock.vue?vue&type=script&lang=js"
export * from "./settingSelectedBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d762359",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d762359')) {
      api.createRecord('2d762359', component.options)
    } else {
      api.reload('2d762359', component.options)
    }
    module.hot.accept("./settingSelectedBlock.vue?vue&type=template&id=2d762359&scoped=true", function () {
      api.rerender('2d762359', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/btn/setting/settingSelectedBlock.vue"
export default component.exports